import { render, staticRenderFns } from "./ChangelogsCard.vue?vue&type=template&id=3acb6316"
import script from "./ChangelogsCard.vue?vue&type=script&lang=js"
export * from "./ChangelogsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports